import cn from 'classnames';

import OPE from 'js/on-page-editing';

import RichText from 'components/rich-text/RichText';

import { ISchedule } from 'source/NFR.types';

const Schedule: React.FC<ISchedule> = ({ programList = [], onPageEditing, lastTitle }) => (
  <div className="schedule" {...OPE(onPageEditing?.programList)}>
    {programList?.map(({ time, title, text, isBreak }, i) => {
      const isLast = i === programList.length - 1;
      return (
        <div className={cn('schedule--item', { 'schedule--item--break': isBreak })} key={time}>
          <div className="schedule--item-time">{time}</div>
          <div className="schedule--item-content">
            <p className="schedule--item-title">{title || (isLast && lastTitle)}</p>
            <RichText {...text} />
          </div>
        </div>
      );
    })}
  </div>
);

Schedule.displayName = 'Schedule';

export default Schedule;
